import React from "react";

import { Row, Col } from "reactstrap";
import RequiredIndicator from "../Form/RequiredIndicator";

export default ({ isInternalUser }) => (
	<Row className="mt-4">
		<Col>
			<h3>California Privacy Rights Act Request Form</h3>
			{isInternalUser ? (
				<p style={{ color: "red", fontStyle: "italic" }}>
					Note for use: This form applies to callers who are residents of
					California and that want to exercise a right to know/access personal
					information we have about them, or to correct their personal
					information, or to delete their personal information. This form does
					not apply to clients who want to opt out of receiving marketing
					materials from TRP related to information shared within the TRP family
					of companies. Refer to the Regulation S-AM Policy to process marketing
					opt-out requests.
				</p>
			) : (
				""
			)}
			{isInternalUser ? (
				<div className="mb-2">
					<RequiredIndicator /> Indicates a required field in the form below.
				</div>
			) : (
				""
			)}
		</Col>
	</Row>
);
